import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var RoleUsersModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RoleUsersModalComponent, _super);
    function RoleUsersModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RoleUsersModalComponent;
}(UiModalComponent));
export { RoleUsersModalComponent };
